function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_7197_27463)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10C18.3337 5.39765 14.6027 1.66669 10.0003 1.66669C5.39795 1.66669 1.66699 5.39765 1.66699 10C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 5V10L13.3333 11.6667",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7197_27463"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));
const SvgClock = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.e58b9711.svg";
export { ForwardRef as ReactComponent };